/** Sort Options taken from SearchContainer.tsx */
const defaultSortOptions = [
  { value: 'most_relevant', label: 'Most Relevant' },
  { value: 'most_downloaded', label: 'Most Downloaded' },
  { value: 'most_recent', label: 'Most Recent' },
  { value: 'trending_now', label: 'Trending Now' },
  { value: 'undiscovered', label: 'Undiscovered' },
];

const audioSortOptions = [
  { value: 'duration_asc', label: 'Duration: Low-High' },
  { value: 'duration_desc', label: 'Duration: High-Low' },
  { value: 'title_asc', label: 'Title: A-Z' },
  { value: 'title_desc', label: 'Title: Z-A' },
];

const videoSortOptions = [
  { value: 'best_aesthetics', label: 'Best Aesthetics' },
];

const stockItemCardResultOptions = Array.from(
  { length: 33 },
  (_, i) => `${(i + 1) * 3}`
);
const MAX_RESULTS_PER_PAGE = parseInt(
  stockItemCardResultOptions[stockItemCardResultOptions.length - 1]
);

const targetAttributeOptions = ['_self', '_blank', '_parent', '_top'];
const browseCategoriesMediaTypesOptions = [
  {
    label: 'All',
    value: 'all-videos',
  },
  {
    label: 'Footage',
    value: 'footage',
  },
  {
    label: 'Backgrounds',
    value: 'motion-backgrounds',
  },
  {
    label: 'Templates',
    value: 'templates',
  },
];

const opacityOptions = [
  {
    label: '45%',
    value: 0.45,
  },
  {
    label: '55%',
    value: 0.55,
  },
  {
    label: '60%',
    value: 0.6,
  },
  {
    label: '65%',
    value: 0.65,
  },
  {
    label: '70%',
    value: 0.7,
  },
  {
    label: '75%',
    value: 0.75,
  },
  {
    label: '80%',
    value: 0.8,
  },
  {
    label: '85%',
    value: 0.85,
  },
  {
    label: '90%',
    value: 0.9,
  },
  {
    label: '95%',
    value: 0.95,
  },
  {
    label: '100%',
    value: 1,
  },
];

const lazyLoadDefaultConfig = {
  name: 'lazyLoadImage',
  type: 'boolean',
  required: false,
  defaultValue: true,
};

const BottomCTASubFields = [
  {
    name: 'text',
    type: 'string',
    required: true,
  },
  {
    name: 'href',
    type: 'string',
    required: true,
  },
  {
    name: 'target',
    type: 'string',
    enum: ['_self', '_blank', '_parent', '_top'],
    helperText:
      'For explanation of options, see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#attr-target',
  },
  {
    name: 'rel',
    type: 'string',
    helperText:
      'For documentation on accepted values, see https://developer.mozilla.org/en-US/docs/Web/HTML/Link_types for link types allowed in <a> elements',
  },
  {
    name: 'variant',
    type: 'string',
    defaultValue: 'outlined-dark',
    enum: [
      { label: 'primary', value: 'primary' },
      { label: 'secondary', value: 'secondary' },
      { label: 'outlined-dark', value: 'outlined-dark' },
      { label: 'outlined-light', value: 'outlined-light' },
      { label: 'text', value: 'text' },
      { label: 'alternate', value: 'alternate' },
    ],
  },
  {
    name: 'size',
    type: 'string',
    defaultValue: 'large',
    enum: [
      { label: 'default', value: 'default' },
      { label: 'large', value: 'large' },
    ],
  },
];

const BottomCTADefaultValue = {
  text: 'Explore all content',
  href: '/',
  target: '_self',
  rel: '',
  variant: 'outlined-dark',
  size: 'large',
};

/**
 * Builder inputs for standalone CTA (AudioCardList, ImageContentGrid, VideoContentGrid)
 */
const BottomCTABuilderInputs = [
  {
    name: 'showCallToAction',
    type: 'boolean',
    defaultValue: true,
  },
  {
    name: 'callToAction',
    type: 'object',
    defaultValue: BottomCTADefaultValue,
    showIf: (options: any) => options.get('showCallToAction'),
    subFields: BottomCTASubFields,
  },
];

export {
  MAX_RESULTS_PER_PAGE,
  audioSortOptions,
  defaultSortOptions,
  stockItemCardResultOptions,
  videoSortOptions,
  targetAttributeOptions,
  browseCategoriesMediaTypesOptions,
  opacityOptions,
  lazyLoadDefaultConfig,
  BottomCTASubFields,
  BottomCTADefaultValue,
  BottomCTABuilderInputs,
};
